import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../shared/shared.module';
import { CoreRoutingModule } from './core-routing.module';
import { CoreComponent } from './core.component';
import { HeaderComponent } from './header/header.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@NgModule({
    declarations: [HeaderComponent, SidebarComponent, CoreComponent, NotFoundComponent],
    imports: [SharedModule, FontAwesomeModule, CoreRoutingModule, ReactiveFormsModule]
})
// skipcq: JS-0327
export class CoreModule { }
